export const dummyBankFeedSmartReconStatement = {
    statement: {
        account_number: "3194506902",
        date: "2019-09-30",
        opening_balance: 132904.16,
        closing_balance: 108239.07,
        items: [
            {
                date: "2019-09-02",
                description: "TSFR FUND DR-ATM/EFT 197800 ENG SHEAU JYE DRAWING",
                amount: -36000,
                closing_balance: 96904.16,
            },
            {
                date: "2019-09-03",
                description: "DEP-ECP 222559 IMEPS20190903100002275175609 MBB SANDBOX SPACE MBB PRIVATE TRANSACTION JYE DEPO REFUND",
                amount: 480,
                closing_balance: 97384.16,
            },
            {
                date: "2019-09-03",
                description: "TSFR FUND DR-ATM/EFT 770469 MUHAMMAD SYAF AUG 2019 SALARY SYAFIQ SALARY 08 19",
                amount: -2649.34,
                closing_balance: 94734.82,
            },
            {
                date: "2019-09-03",
                description: "TSFR FUND DR-ATM/EFT 772777 ENG SHEAU JYE SALARY JYE AUG19 SALARY JYE AUG19",
                amount: -2649.35,
                closing_balance: 92085.47,
            },
            {
                date: "2019-09-03",
                description: "DR-ECP 782348 1909032102260314 PERTUBUHAN KESELAMATAN SOSIAL 20190903210044_4323594 FPX - RHB0218",
                amount: -132.8,
                closing_balance: 91952.67,
            },
            {
                date: "2019-09-03",
                description: "DR-ECP 790135 1909032105000480 PERTUBUHAN KESELAMATAN SOSIAL 20190903210318_22718210 FPX - RHB0218",
                amount: -23.6,
                closing_balance: 91929.07,
            },
            {
                date: "2019-09-03",
                description: "DR-ECP 800079 1909032107510775 KUMPULAN WANG SIMPANAN PEKERJA 0920190021613606C109336738 FPX - MBB0228",
                amount: -1440,
                closing_balance: 90489.07,
            },
            {
                date: "2019-09-18",
                description: "INSTANT TRSF CR 022952 CHEANG LAI YEE HAYDEN THANK YOU, JYE",
                amount: 420,
                closing_balance: 90909.07,
            },
            {
                date: "2019-09-23",
                description: "DEP-ECP 198220 IMEPS20190923100002276317843 MBB SANDBOX SPACE MBB PRIVATE TRANSACTION IVAN DEPO REFUN",
                amount: 480,
                closing_balance: 91389.07,
            },
            {
                date: "2019-09-23",
                description: "DEP-ECP 222781 IMEPS20190923100002276506030 MBB HERMO CREATIVE (M) SDN BHD MBB OUTWARD ACH FL190918990673 HERMO CREA TIVE (M) S",
                amount: 28800,
                closing_balance: 120189.07,
            },
            {
                date: "2019-09-24",
                description: "TSFR FUND DR-ATM/EFT 372329 ENG SHEAU JYE DRAWING",
                amount: -15000,
                closing_balance: 105189.07,
            },
            {
                date: "2019-09-30",
                description: "INSTANT TRSF CR 016254 NUR FATEHAH BINTI MO MACBOOK AIR",
                amount: 3050,
                closing_balance: 108239.07,
            },
        ],
        count: 12,
    },
};
